module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    class: [
      'form',
      {
        'form--wide': _vm.wide,
      } ],
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_vm._l((_vm.fields), function(field, key) {
    return [((field.heading || {}).heading) ? _c(field.heading.tag || "h3", {
      key: ("fieldset-heading-" + key),
      tag: "component",
      class: [
        "form__field-heading",
        field.heading.level || "h2" ],
      domProps: {
        "innerHTML": _vm._s(field.heading.heading)
      }
    }) : _vm._e(), _vm._v(" "), (field.tooltip) ? _c('div', {
      key: ("tooltip-" + key)
    }, [_c('a', {
      class: [("expand-button-" + key), "link", "link--secondary", "tdn"],
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(field.tooltip.title))]), _vm._v(" "), _c('Expander', {
      attrs: {
        "trigger-element": (".expand-button-" + key)
      }
    }, [_c('ui-tooltip', {
      attrs: {
        "level": "tip",
        "close": false
      }
    }, [_c('template', {
      slot: "message"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(field.tooltip.content)
      }
    })])], 2)], 1)], 1) : _vm._e(), _vm._v(" "), ((field.intro || {}).copy) ? _c('p', {
      key: ("fieldset-intro-" + key),
      class: [
        "form__field-intro",
        field.intro.size || "p",
        {
          'mt0': !!(field.heading || {}).heading,
        } ],
      domProps: {
        "innerHTML": _vm._s(field.intro.copy)
      }
    }) : _vm._e(), _vm._v(" "), _c('module-form-fieldset', {
      key: ("fieldset-" + key),
      attrs: {
        "form-id": _vm.formId,
        "field": field,
        "field-id": key,
        "server-error": _vm.serverErrors[key]
      },
      on: {
        "fieldTouch": function($event) {
          _vm.onFieldTouch(key)
        },
        "fieldReset": function($event) {
          _vm.onFieldReset(key)
        }
      }
    })]
  }), _vm._v(" "), (_vm.serverErrors._global) ? _c('p', {
    class: "form__errors small"
  }, [_vm._v(_vm._s(_vm.serverErrors._global))]) : _vm._e(), _vm._v(" "), _vm._t("before-submit"), _vm._v(" "), (!_vm.noSubmit) ? _c('div', {
    class: [_vm.hideSubmit ? 'visuallyhidden' : 'form__submit']
  }, [_c('module-button', {
    class: [{
      'btn--hidden': _vm.hideSubmit,
    }],
    attrs: {
      "button": _vm.button || '',
      "size": _vm.buttonSize || '',
      "disabled": _vm.$v.$invalid || _vm.invalid,
      "loading": _vm.status.loading,
      "success": _vm.status.success,
      "type": "submit",
      "dark": _vm.buttonDark
    }
  }, [_vm._v("\n      " + _vm._s(_vm.submit || "Submit") + "\n    ")]), _vm._v(" "), _vm._t("submit-extras")], 2) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fa08fa0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/Form.vue
// module id = 113
// module chunks = 3